import {
  ClockCircleOutlined,
  DatabaseOutlined,
  LinkOutlined,
  NumberOutlined,
  WarningOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { Divider, Space, Tooltip, Typography } from "antd";
import { ResponseInputEquipments } from "api/generated";
import EquipmentCard from "common/components/widgets/equipments/EquipmentCard";
import { useMemo } from "react";

interface EntryEquipmentCardProps {
  equipment: ResponseInputEquipments;
}

function RegEntradaCard({ equipment }: EntryEquipmentCardProps) {
  const hasSerialNumber: boolean = useMemo(
    () => equipment.serialNumber !== undefined,
    [equipment],
  );

  return (
    <EquipmentCard
      icon={<LoginOutlined style={{ fontSize: 36, color: "white" }} />}
      status={equipment.status ?? "DESCONOCIDO"}
      isActive={equipment.isActive ?? false}
      content={
        <div style={{ padding: 16 }}>
          <div style={{ marginBottom: 12 }}>
            <Typography.Text strong style={{ fontSize: 16, display: "block" }}>
              {equipment.equipmentKey ?? "—"}
            </Typography.Text>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {equipment.applicationType === "TRASPASOS_ENT"
                ? "Equipo de Traspaso"
                : "Equipo de entrada"}
            </Typography.Text>
          </div>

          <Divider style={{ margin: "10px 0" }} />

          <Space direction="vertical" style={{ width: "100%" }} size={6}>
            {equipment.wareHouseKey && (
              <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <DatabaseOutlined style={{ color: "#52c41a", fontSize: 13 }} />
                <Typography.Text style={{ fontSize: 12 }}>
                  Almacén:{" "}
                  <Typography.Text strong style={{ fontSize: 12 }}>
                    {equipment.wareHouseKey}
                  </Typography.Text>
                </Typography.Text>
              </div>
            )}

            {equipment.warehouseCode && (
              <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <NumberOutlined style={{ color: "#1890ff", fontSize: 13 }} />
                <Typography.Text style={{ fontSize: 12 }}>
                  Codigo:{" "}
                  <Typography.Text code>
                    {equipment.warehouseCode}
                  </Typography.Text>
                </Typography.Text>
              </div>
            )}
            {hasSerialNumber && (
              <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <LinkOutlined style={{ color: "#722ed1", fontSize: 13 }} />
                <Typography.Text style={{ fontSize: 12 }}>
                  Serie:{" "}
                  <Tooltip title="Número de serie del equipo GasPar">
                    <Typography.Text code>
                      {equipment.serialNumber}
                    </Typography.Text>
                  </Tooltip>
                </Typography.Text>
              </div>
            )}
          </Space>
        </div>
      }
      footer={
        <div>
          {hasSerialNumber ? (
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <ClockCircleOutlined style={{ color: "#52c41a", fontSize: 13 }} />
              <Typography.Text
                type={
                  equipment.lastCommunicationDate &&
                  equipment.lastCommunicationDate !== "Sin comunicación"
                    ? "secondary"
                    : "danger"
                }
                style={{ fontSize: 12 }}
                ellipsis={{
                  tooltip:
                    equipment.lastCommunicationDate ?? "Sin comunicación",
                }}
              >
                {equipment.lastCommunicationDate ?? "Sin comunicación"}
              </Typography.Text>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
              <WarningOutlined style={{ color: "#faad14", fontSize: 13 }} />
              <Typography.Text type="warning" style={{ fontSize: 12 }}>
                Sin equipo GasPar enlazado
              </Typography.Text>
            </div>
          )}
        </div>
      }
    />
  );
}

export default RegEntradaCard;
